"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";

type UseRouteChangeParams = {
  onChangeStart?: () => void;
  onChangeComplete?: () => void;
};

const useRouteChange = ({
  onChangeStart,
  onChangeComplete,
}: UseRouteChangeParams) => {
  const pathname = usePathname();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    if (prevPathnameRef.current !== pathname) {
      if (onChangeStart) {
        onChangeStart();
      }
      if (onChangeComplete) {
        onChangeComplete();
      }
      prevPathnameRef.current = pathname;
    }
  }, [pathname, onChangeStart, onChangeComplete]);
};

export default useRouteChange;
